import axios from "../utils/axiosConfig";
import {ILedgerResponse,ILedgerParams } from "../Interfaces/ILedger"
const { BASE_URL } = require("../utils/urls");
/**
 * Fetch customer ledger entries.
 * - Pass `customerId` to scope to a single customer + get outstanding balance.
 * - Omit `customerId` to fetch all entries across the org.
 */
export const getLedger = async (params: ILedgerParams): Promise<ILedgerResponse> => {
  try {
    const response = await axios.get(`${BASE_URL}/api/customerLedger/getCustomerLedger`, {
      params: {
        orgId:      params.orgId,
        customerId: params.customerId || undefined,
        entryType:  params.entryType  || undefined,
        fromDate:   params.fromDate   || undefined,
        toDate:     params.toDate     || undefined,
        page:       params.page       ?? 1,
        limit:      params.limit      ?? 10,
      },
    });
    return response.data;
  } catch (error: any) {
    console.error("Error fetching ledger:", error?.response?.data?.message || error?.message);
    throw new Error(error?.response?.data?.message || "Failed to fetch ledger");
  }
};